import readRedesignAccount from './readRedesignAccount';
import fetchRedesignAccount from './fetchRedesignAccount';

const ACCOUNT_FIELDS = [
    'role',
    'operatorCapacity',
    'logoutUrl',
    'settingsUrl',
    'fullName',
    'email',
    'stopImpersonatingUrl',
];

const listeners = new Set();

let currentAccount = null;
let pendingRefresh = null;

function getRedesignAccount() {
    if (currentAccount === null) {
        currentAccount = readRedesignAccount();
    }

    return currentAccount;
}

function describesSameAccount(left, right) {
    return ACCOUNT_FIELDS.every(field => left[field] === right[field]);
}

function publishAccount(account) {
    if (describesSameAccount(getRedesignAccount(), account)) {
        return;
    }

    currentAccount = account;
    listeners.forEach(listener => listener());
}

function refreshRedesignAccount() {
    if (pendingRefresh !== null) {
        return pendingRefresh;
    }

    pendingRefresh = fetchRedesignAccount().then(
        (account) => {
            pendingRefresh = null;
            publishAccount(account);
        },
        () => {
            pendingRefresh = null;
        },
    );

    return pendingRefresh;
}

function refreshWhenTabBecomesVisible() {
    if (document.visibilityState === 'visible') {
        refreshRedesignAccount();
    }
}

function listensForVisibility() {
    return typeof document !== 'undefined' && typeof document.addEventListener === 'function';
}

function subscribeToRedesignAccount(listener) {
    if (listeners.size === 0 && listensForVisibility()) {
        document.addEventListener('visibilitychange', refreshWhenTabBecomesVisible);
    }

    listeners.add(listener);

    return () => {
        listeners.delete(listener);
        if (listeners.size === 0 && listensForVisibility()) {
            document.removeEventListener('visibilitychange', refreshWhenTabBecomesVisible);
        }
    };
}

function resetRedesignAccountStore() {
    listeners.clear();
    currentAccount = null;
    pendingRefresh = null;
    if (listensForVisibility()) {
        document.removeEventListener('visibilitychange', refreshWhenTabBecomesVisible);
    }
}

export {
    getRedesignAccount,
    refreshRedesignAccount,
    subscribeToRedesignAccount,
    resetRedesignAccountStore,
};
